import { z } from 'zod/v4';

import { ApiIntegrationStatusRuntype } from './3rdPartyBackendTypes';

export type LcscLocaleCurrencyDTO = z.infer<typeof LcscLocaleCurrencyDTORuntype>;
export const LcscLocaleCurrencyDTORuntype = z.enum(['EUR', 'USD', 'HKD', 'CNY', 'CNYNoTax']);

export interface LcscCredentialsDTO extends z.infer<typeof LcscCredentialsDTORuntype> {}
export const LcscCredentialsDTORuntype = z.object({
    api_key: z.string(),
    api_secret: z.string(),
    currency: LcscLocaleCurrencyDTORuntype,
});

export interface LcscCredentialsInputDTO extends z.infer<typeof LcscCredentialsInputDTORuntype> {}
export const LcscCredentialsInputDTORuntype = z.object({
    api_key: z.string().optional(),
    api_secret: z.string().optional(),
    currency: LcscLocaleCurrencyDTORuntype.optional(),
});

export interface LcscResponseBodyDTO extends z.infer<typeof LcscResponseBodyDTORuntype> {}
export const LcscResponseBodyDTORuntype = z.object({
    data: LcscCredentialsDTORuntype.nullable(),
    status: ApiIntegrationStatusRuntype,
});
